import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';
import {FormMultiPart, Stream} from '@/apis/base/httpclient';

class DesignReportAPI extends BaseAPI {
  apiName = 'BU';
  controllerName = 'DesignReports';

  /**
   * Lấy dữ liệu báo cáo
   * tvhien 21.08.2023
   */
  getHtmlReport(reportID, reportKey, isGetFileDefault) {
    let request = {
      url: this.getAPIUrl() + `/edit/${reportKey}/${isGetFileDefault}`,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy file xslt bìa cáo cáo 
   * @param {} reportID 
   * @param {} isGetFileDefault 
   * @param {} key 
   * @returns 
   * dqvinh 12.1.2023
   * Modifie: HMDUC2 02/02/2024
   */
  getHtmlCoverReport(reportId,key,isGetFileDefault) {
    //HMDUC2:  Case TH reportId có kí tự đặc biệt replace và lên BE sẽ replace ngược lại
    if(reportId.includes("/")){
      reportId = reportId.replace("/", "_slash_");
    }

    // HMDUC2:Không truyền reportFile nữa, Sẽ lấy trên BE theo reportId. 
    let request = {
      url: this.getAPIUrl() + `/editCover/${reportId}/${key}/${isGetFileDefault}`,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Kiểm tra mẫu đã sửa hay chưa
   * @param {*} reportId
   * @returns
   */
  checkReportEdited(reportId, isCheckReportFile, reportFile) {
    //nxhoa 9.10.2023: bổ sung thêm tham số check theo tên file mẫu báo cáo nếu cần thiết
    isCheckReportFile =
      isCheckReportFile == null || typeof isCheckReportFile == 'undefined' ? false : !!isCheckReportFile;
    reportFile = reportFile == null || typeof reportFile == 'undefined' ? 'undefined' : reportFile;

    /**
     * 18.10.2023 nxhoa chuyển sang method post
     */
    let data = {
      Data: JSON.stringify({
        reportId: reportId,
        isCheckReportFile: isCheckReportFile,
        reportFile: reportFile,
      }),
    };

    let request = {
      url: this.getAPIUrl() + `/checkReportEdited`,
      data: data,
    };
    return httpClient.postAsync(request);
  }

  /**
   * thực hiện cất mẫu
   * @param {*} id
   * @param {*} data
   * tvhien 28.08.2023
   */
  saveHtmlTemplate(id, option) {
    let request = {
      url: this.getAPIUrl() + `/save/${id}`,
      data: option,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Cất bìa
   * @param {} id 
   * @param {*} option 
   * @returns 
   */
  saveCoverHtmlTemplate(id, option) {
    let request = {
      url: this.getAPIUrl() + `/saveCover`,
      data: option,
    };

    return httpClient.postAsync(request);
  }

  /**
   * hàm check tồn tại mẫu báo cáo
   * @param {*} option 
   * hmduc2 22/11/2023
   */
  checkExistTemplate(option){
    let request = {
      url: this.getAPIUrl() +  `/checkExistTemplate`,
      data: option,
    }
    return httpClient.postAsync(request);
  }

  /**
   * Lấy danh sách background
   * tvhien 30.08.2023
   */
  getBackGroundList() {
    let request = {
      url: this.getAPIUrl() + `/backgrounds`,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy danh sách background bìa
   * dqvinh 11.3.2023
   */
  getBackGroundCoverList() {
    let request = {
      url: this.getAPIUrl() + `/background_covers`,
    };

    return httpClient.getAsync(request);
  }

  

  /**
   * Upload file
   * @param {*} file : File upload
   * @param {*} type : Loại file
   * @param {*} is_cover : là upload bìa hay sửa mẫu
   */
  upload(file, type, is_cover = false) {
    let data = new FormData();
    data.append('file', file);
    data.append('is_cover', is_cover);
    if (type) {
      data.append('type', type);
    }

    let request = {
      url: [this.getAPIUrl(), 'upload'].join('/'),
      data: data,
    };

    return this.postAsync(request, false, true, FormMultiPart);
  }

  /**
   * thực hiện lấy link file
   * @param {*} key
   * @param {*} fileName
   * @param {*} isPrintCovcer
   * @returns
   * tvhien 14.09.2023
   * Modified: HMDUC2: 27/02/2024 Thêm thamn số có in bìa hay không mặc định là không
   */
  getPrintLink(key, fileName, isPrintCovcer = false) {
    return [window._apis.ReportDesignRender, 'view', key, fileName, isPrintCovcer].join('/');
  }

/**
 * Thực hiện lấy link in theo lô
 * @param {*} key 
 * @param {*} fileName 
 * @returns 
 * dqvinh 26.10.2023
 */
  getPrintBatchLink(key, fileName, isPrintCovcer = false) {
    return [window._apis.ReportDesignRender, 'print-batch', key, fileName, isPrintCovcer].join('/');
  }


  /**
   * lấy link gọi download file
   * @param {*} file : tên file server
   * @param {*} name : Tên file lưu về
   * @param {*} ext :định dạng file
   */
  getDownloadLink(key, name, ext, isBatch) {
    return [window._apis.ReportDesignRender, 'download', key, name, ext, isBatch].join('/');
  }

  /**
   * link xem mẫu
   * @param {*} key
   * @param {*} name
   * @param {*} ext
   * @returns
   */
  getPreview(key, name) {
    return [window._apis.ReportDesignRender, 'preview', key, name].join('/');
  }

  /**
   * Save tham số khi in
   * @param {*} param
   * @returns
   */
  saveParamter(param) {
    let url = [this.getAPIUrl()].join('');
    return this.postAsync({
      url: url,
      data: param,
    });
  }
}

export default new DesignReportAPI();
